import type * as React from 'react';

function SvgPadlock(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M20 9H16.4502V6C16.1978 3.7562 14.3103 2 12 2C9.6897 2 7.803 3.7562 7.5505 6L7.5498 9H4C3.4473 9 3 9.4478 3 10V21C3 21.5522 3.4473 22 4 22H20C20.5527 22 21 21.5522 21 21V10C21 9.4478 20.5527 9 20 9ZM9.5498 6C9.7821 4.8603 10.7923 4 12 4C13.2077 4 14.2172 4.8603 14.4495 6L14.4502 9H9.5498V6ZM19 20H5V11H19V20Z"
        fill="currentColor"
      />
      <path
        d="M11.25 15.792V17.2998C11.25 17.7139 11.5859 18.0498 12 18.0498C12.4141 18.0498 12.75 17.7139 12.75 17.2998V15.792C13.1965 15.5322 13.5 15.0538 13.5 14.5C13.5 13.6716 12.8284 13 12 13C11.1716 13 10.5 13.6716 10.5 14.5C10.5 15.0538 10.8035 15.5322 11.25 15.792Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgPadlock;
